import React, { useEffect } from 'react';
import t from '@jetshop/intl';
import { trackPageEvent } from '@jetshop/core/analytics/tracking';
import { useTracker } from '@jetshop/core/analytics/Analytics';
import SearchPageBehaviour from '@jetshop/ui/Search/SearchPage/SearchPageBehaviour';
import SearchResults from './SearchResults';
import EmptySearchResults from './EmptySearchResults';
import SearchQuery from './SearchQuery.gql';
import { useLocation } from 'react-router';

const renderResults = searchProps =>
  searchProps.total > 0 || searchProps.loading ? (
    <SearchResults {...searchProps} />
  ) : (
    <EmptySearchResults term={searchProps.term} result={searchProps.result} />
  );

const SearchPage = () => {
  const track = useTracker();
  const location = useLocation();
  const { pathname, search } = location;

  useEffect(() => {
    track(trackPageEvent({ pathname: `${pathname}${search}` }));
  }, [track, pathname, search]);

  return (
    <>
      <SearchPageBehaviour searchQuery={SearchQuery} location={location}>
        {({ error, ...searchProps }) =>
          error ? (
            <div error={error}>{t('An error occured. Please try again!')}</div>
          ) : (
            renderResults(searchProps)
          )
        }
      </SearchPageBehaviour>
    </>
  );
};

export default SearchPage;
